// extracted by mini-css-extract-plugin
var _1 = "CwoMac3kUXHUdxPU1pKb";
var _2 = "yZTa4MJ87Kh1D0ztFe0X";
export { _1 as "flash", _2 as "tile-skeleton" }
